import styled from "styled-components";
import { RAImage, RATypography } from "@/components/customs";
import { Modal } from "antd";
import { IconCloseSvg } from "@/components/svgs";
import { IconError, IconSuccess } from "@/assets/images";
import { NOTIFICATION_TYPE } from "@/config/constants";

const getIconStatus = (status) => {
	switch (status) {
		case NOTIFICATION_TYPE.SUCCESS:
			return IconSuccess;
		case NOTIFICATION_TYPE.ERROR:
			return IconError;
		default:
			return IconSuccess;
	}
};

export function ModalStatus({ visible = false, onClose, status, title = "", note = "", footer }) {
	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => onClose()}
			footer={null}
			width="auto"
			style={{ padding: 0 }}
			wrapClassName="auth-wrapper"
		>
			<Container data-testid="StatusModal_content">
				<RAImage url={getIconStatus(status)} width="50px" height="50px" />
				<RATypography variant="h4" align="center">
					{title}
				</RATypography>
				{!!note && (
					<RATypography variant="body3" color="#595959" align="center">
						{note}
					</RATypography>
				)}
				{footer}
			</Container>
		</Modal>
	);
}

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 20px;
	justify-content: center;
	align-items: center;
	max-width: 600px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);

	@media (max-width: 767px) {
		min-width: 100%;
	}
`;
